import ProfileCreate from '@containers/profile/ProfileCreate';

const ProfileCreatePage = () => {
  return <ProfileCreate />;
};

export default ProfileCreatePage;
